<template>
<div class="np-alert np-alert-ani" v-if="showAlert"
	:class="setAlertClass">
	<!-- 确认弹窗  -->
	<div class="np-alert-confirm_box" ref="npAlertBox"
		:class="{'np-alert_show':showClass,'np-alert-ani':!moveStart && !resizeStart}"
		:style="{width: opts && opts.area?opts.area[0]:false,height: opts && opts.area? opts.area[1]:false}"
	>
		<div class="np-alert-title" :style="opts.titleStyle" @mousedown="mousedown" v-if="opts && opts.title" ref="npAlertTitle">
			<span class="np-alert-title-text" v-html="opts.title"></span>
		</div>
		<i class="np-alert-close icon" v-if=" opts.closeBtn === undefined || opts.closeBtn" @click="closeBtnClick">
			&#xe678;
		</i>
		<div class="np-alert-content" :style="opts.contentStyle" ref="npAlertContent" v-if="opts.content" v-html="opts.content"></div>
		<!-- 自定义content -->
		<div class="np-alert-content" :style="opts.contentStyle" ref="npAlertContent" v-else>
			<slot name="content" ></slot>
		</div>
		<div class="np-alert-btns"  ref="npAlertBtns" :style="{'text-align':opts.btnAlign?opts.btnAlign:'center'}" v-if="opts.btns === undefined || opts.btns">
			<template v-if="opts.btns instanceof Array">
				<template v-for="(v,i) in opts.btns">
					<a :key="i"
						:class="setBtnskin(v,i)"
						:style="v.style"
						:href="v.href || 'javascript:void(0);'"
						@click="btnClick(v,i)"
					>
					{{v.text || v}}
					<i class="layui-icon layui-icon-loading layui-anim layui-anim-rotate layui-anim-loop btn-loading"></i>
					</a>
				</template>
			</template>
			<template v-else>
				<a class="np-alert-btns_btn0" href="javascript:void(0);" @click="btnClick('cancle')">cancle</a>
				<a class="np-alert-btns_btn1" href="javascript:void(0);" @click="btnClick('yes')">confirm</a>
			</template>
		</div>
		<span class="np-alert_resize" @mousedown="resizedown" ></span>
	</div>
	<div class="np-alert-bg np-alert-ani" @click="shadeClose" ></div>
</div>
</template>
<script>
/*
	功能描述 type 1 .msg方法
	1，弹窗---半遮罩弹窗 类似layer.msg
	2，loading 弹窗 类似线上gifloading动画
	//.
*/
export default {
	props:[
		"show",
		"duration",
		"onClose",
		//confirm
		"options",
		"area"
	],
	data:function(){
		return {
			showClass:false,
			showAlert: false,
			moveStart: false,
			resizeStart: false,
			//最小高度
			minHeight: 120,
			resize:{},
			move:{},
			opts:{}
		}
	},
	computed:{
		setAlertClass: function(){
			var opts= this.opts;
			var rst =  {
				'np-alert_show':this.showClass,
				'np-alert-confirm':true
			}
			//设置class
			if(opts.skin){
				rst[opts.skin] = true;
			}
			return rst;
		}
	},
	created: function(){
		this.opts = this.options || {};
		//设置option参数
		if(this.opts instanceof Object){
			this.setopts();
		}
	},
	mounted: function(){
		var _this = this;
			_this.showAlert = _this.show;
		setTimeout(function(){
			_this.showClass = _this.show;
			//載入初始化，更具内容 或者 參數 設置高寬
			_this.setContentArea();
		});
		//如果有設置自動關閉
		if(_this.opts.duration){
			_this.autoClose();
		}
		//接受opts
		/*
		onClose ： 关闭回调
		可配置项
			1，title	标题
			2，skin	皮肤样式
			3，area	宽高
			4，btn	提示按钮
			5，closeBtn  右上关闭
			6，shade 遮罩
			7，shadeClose 点击遮罩关闭
			8，time 自动关闭
			9，yes 确定回调
			10，cancle: 取消回调
			11 、outMove:true 允許移動出 window框， 默認不允許
			12 canMove 是否可拖動
			13 canResize
		*/
		/*
		按钮特殊传值和回调方式
			btns:[{
				text:"ok",
				skin: 按钮样式,
				callBack: function(e){
					console.log(e)
				}
			},"确定"],
			"确定": function(e){
				//e 为当前组件this
				console.log(e)
			}
		*/
	},
	methods:{
		setopts: function(){
			if(this.opts.canMove === undefined){
				this.opts.canMove = true;
			}
			if(this.opts.canResize === undefined){
				this.opts.canResize = true;
			}
		},
		setBtnskin: function(v,i){
			//设置按钮样式，可以通过 skin传值改变按钮样式
			var tmp = {};
			if(v.skin){
				tmp[v.skin] = true;
			}
			if(i == 0){
				tmp["np-alert-btns_btn0"] = true;
			}else{
				tmp["np-alert-btns_btn1"] = true;
			}
			return tmp;
		},
		autoClose: function(){
			var _this = this, duration = _this.opts.duration;
			//自动关闭
			setTimeout(function(){
				_this.close();
			},duration);
		},
		shadeClose: function(){
			if(this.opts.shadeClose){
				this.close();
			}
		},
		btnClick: function(v,i){
			if(v && typeof v.callBack === "function"){
				return v.callBack(this,i);
			}
			if(typeof v === "string"){
				if(typeof this.opts[v] === "function"){
					this.opts[v](this)
				}else{
					this.close();
				}
			}
		},
		//
		closeBtnClick: function(){
			if(typeof this.opts.closeBtn === "function"){
				this.opts.closeBtn(this);
			} else {
				this.close();
			}
		},
		//
		setContentArea: function(){
			var npTitle = this.$refs.npAlertTitle||{},
				npBox = this.$refs.npAlertBox||{},
				npContent = this.$refs.npAlertContent||{},
				npBtn = this.$refs.npAlertBtns||{};
			var titleHeight = npTitle.offsetHeight || 0,
				btnHeight = npBtn.offsetHeight || 0;
				if(this.opts.area){
					npBox.style.width = this.opts.area[0];
					if(this.opts.area[1]) {
						npBox.style.height = this.opts.area[1];
						npContent.style.height = (npBox.offsetHeight - titleHeight - btnHeight) + "px";
					}
				}else{
					var contentHeight = npContent.offsetHeight,
						contentWidth = npContent.offsetWidth,
						//盒子高度 = 内容高度 + 標題高度 + 按鈕高度；
						boxHeight = contentHeight + titleHeight + btnHeight,
						boxWidth = contentWidth;
						//如果小於最低高度
						if( boxHeight < this.minHeight ){
							boxHeight = this.minHeight;
							npContent.style.minHeight = (boxHeight - titleHeight - btnHeight) + "px";
						}
						//如果 盒子高度 > 窗口高度 超出窗口
						if(boxHeight >= window.innerHeight ){
							// 設置為窗口高度的90%
							boxHeight = window.innerHeight ;
							//内容超出需要設置最大高度以便内容滾動需要
							npContent.style.maxHeight = (boxHeight - titleHeight - btnHeight) + "px";
						}
						//如果 盒子寬度 > 窗口寬度  超出窗口
						if(boxWidth >= window.innerWidth ){
							//設置為窗口寬度的90%
							boxWidth = window.innerWidth ;
						}
					//設置盒子高寬
						/*
						獲取的高寬存在1px誤差 加1保證不會換行
						*/
					npBox.style.width =  boxWidth + 1 + "px";
					npBox.style.height =  boxHeight + 1 + "px";
					//再次獲取content高度
					var newContentHeight = npContent.offsetHeight;
					if(newContentHeight != contentHeight){
						//高度發生改變需要重新計算
						this.setContentArea();
					}
				}
		},

		//拖动弹窗
		mousedown: function(e){
			if(!this.opts.canMove){
				return;
			}
			var npBox = this.$refs.npAlertBox;
				this.moveStart = true;
				//獲取window 高寬
				this.move.winWidth = window.innerWidth;
				this.move.winHeight = window.innerHeight;
				//保存鼠標開始拖動時的坐標
				this.move.startX = e.clientX;
				this.move.startY = e.clientY;
				//獲取鼠標開始拖動時 彈出窗在屏幕中的位置
				this.move.startLeft = (npBox.offsetLeft/this.move.winWidth)*100;
				this.move.startTop = (npBox.offsetTop/this.move.winHeight)*100;
				//給window綁定鼠標移動事件
				window.addEventListener("mousemove",this.onmousemove);
				//同時給window綁定鼠標擡起事件
				window.addEventListener("mouseup",this.mouseup);
		},
		onmousemove: function(e){
			//鼠標已經按下
			if(this.moveStart){
				//獲取需要拖動的盒子
				var npBox = this.$refs.npAlertBox;
				//鼠標拖動時 計算x軸和y軸 拖動距離
				var	moveX = this.move.startLeft + ((e.clientX - this.move.startX)/this.move.winWidth)*100,
					moveY = this.move.startTop + ((e.clientY - this.move.startY)/this.move.winHeight)*100;
					if(!this.opts.outMove){
						//邊界控制
						var boxPercentWidth = ((npBox.offsetWidth/this.move.winWidth) * 100)/2,
							boxPercentHeight = ((npBox.offsetHeight/this.move.winHeight) * 100)/2;
							//左邊
							if(  moveX - boxPercentWidth <= 0){
								moveX = boxPercentWidth;
							}
							//右邊
							if(  moveX + boxPercentWidth >= 100){
								moveX = 100 - boxPercentWidth;
							}
							//上邊
							if(  moveY - boxPercentHeight <= 0){
								moveY = boxPercentHeight;
							}
							//下邊
							if(  moveY + boxPercentHeight >= 100){
								moveY = 100 - boxPercentHeight;
							}
					}
					npBox.style.left =  moveX + "%";
					npBox.style.top =  moveY + "%";
			}
		},
		resizedown: function(e){
			if(!this.opts.canResize){
				return;
			}
			var npBox = this.$refs.npAlertBox;
				this.resizeStart = true;
				//獲取鼠標移動到上面初始坐標
				this.resize.startX = e.clientX;
				this.resize.startY = e.clientY;
				//獲取初始box高寬
				this.resize.startWidth = npBox.offsetWidth;
				this.resize.startHeight = npBox.offsetHeight;
				//添加鼠標移動和擡起事件
				window.addEventListener("mousemove",this.resizemove);
				window.addEventListener("mouseup",this.mouseup);
		},
		resizemove: function(e){
			if(e.stopPropagation) e.stopPropagation();
			if(e.preventDefault) e.preventDefault();
			if(this.resizeStart){
				var npBox = this.$refs.npAlertBox,
					npTitle = this.$refs.npAlertTitle||{},
					npContent = this.$refs.npAlertContent||{},
					npBtn = this.$refs.npAlertBtns||{},
					//x軸和y軸拖動的距離
					resizeX = e.clientX - this.resize.startX,
					resizeY = e.clientY - this.resize.startY,
					boxHeight = this.resize.startHeight + resizeY,
					boxWidth = this.resize.startWidth + resizeX;
					//設置 不允許超過windown邊界
					if(boxWidth/2 - npBox.offsetLeft >= 0){
						boxWidth = npBox.offsetLeft * 2;
					}
					if(boxWidth/2 + npBox.offsetLeft >= window.innerWidth){
						boxWidth = (window.innerWidth - npBox.offsetLeft)*2;
					}
					if(boxHeight/2 - npBox.offsetTop >= 0){
						boxHeight = npBox.offsetTop * 2;
					}
					if(boxHeight/2 + npBox.offsetTop >= window.innerHeight){
						boxHeight = (window.innerHeight - npBox.offsetTop)*2;
					}
					//賦值
					npBox.style.width = boxWidth  + "px";
					npBox.style.height = boxHeight + "px";
					//設置内部content高度 寬度不需要計算
				var titleHeight = npTitle.offsetHeight || 0,
					btnHeight = npBtn.offsetHeight || 0,
					contentHeight = boxHeight - titleHeight - btnHeight;
					npContent.style.height = contentHeight + "px";
					npContent.style.maxHeight = contentHeight + "px";
			}
		},
		mouseup: function(){
			this.moveStart = false;
			//取消窗口拖動事件綁定
			window.removeEventListener("mousemove",this.onmousemove);
			//取消窗口拖動修改大小事件綁定
			this.resizeStart = false;
			window.removeEventListener("mousemove",this.resizemove);
			//取消鼠標擡起事件綁定
			window.removeEventListener("mouseup",this.mouseup);
		},
		close:function(){
			var _this = this;
				_this.showClass = false;
				//removestyle
			try{
				var npAlertBox = this.$refs.npAlertBox;
				if(npAlertBox && npAlertBox.style){
					//動畫
					npAlertBox.style.top = "110%";
					npAlertBox.style.left = "50%";
					/*可自定義動畫
					 var oldcss = npAlertBox.style.cssText;
					npAlertBox.style.cssText  = oldcss + "top:50%; -webkit-transform: translate(-50%,-50%) scale(0);"; */
				}
			}catch(e){
				console.log(e.message)
			}
			if(typeof _this.onClose === "function"){
				_this.onClose();
			}
			setTimeout(function(){
				_this.showAlert = false;
				_this.$emit('closeConfirm')
			},150);
		}
	}
}
</script>
<style lang="scss">
$alert-btn-color: $color-purple;
$alert-color:$color-white;
$alert-padding: $space-padding-md;
$alert-rs: $border-radius-xs;
$alert-confirm-minwidth: 240px;
$alert-confirm-minheight: 120px;
$title-height: 42px;
$title-bg: $color-bg;
$alert-resize-wh:$space-padding-md;
$alert-btn-height: 30px;
$btn-box-height: $alert-padding *2 + $alert-btn-height;
$alert-hover-border-color: #ddd;
.np-alert-ani {
	@include  trans-animate-easeout();
}
.np-alert {
	z-index: 3988;
	//np-alert-content
	&-content {
		box-sizing: border-box;
		padding: 20px;
		overflow: auto;
		word-wrap: break-word;
		//min-height: $alert-confirm-minwidth - $title-height - $btn-box-height;
		//padding-bottom: $btn-box-height;
	}
	&-confirm_box{
		position: fixed;
		left: 50%;
		border-radius: $alert-rs;
		-webkit-transform: translate(-50%,-50%);
		-ms-transform: translate(-50%,-50%);
		-moz-transform: translate(-50%,-50%);
		transform: translate(-50%,-50%);
	}
	//np-alert-confirm_box
	&-confirm_box {
		overflow: hidden;
		z-index: 1;
		top: 110%;
		min-width: $alert-confirm-minwidth;
		min-height: $alert-confirm-minheight;
		background-color: $color-white;
		box-shadow: 0 0 $space-padding-xl rgba(0,0,0,0.4) ;
	}
	//np-alert_show
	&_show {
		left: 50%;
		top: 50%;
	}
	//np-alert_resize
	&_resize {
		position: absolute;
		width: $alert-resize-wh;
		height: $alert-resize-wh;
		cursor: se-resize;
		right: 0;
		bottom: 0;
	}
	//np-alert-confirm
	&-confirm,&-bg {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
	}
	//np-alert-bg
	&-bg {
		background-color: rgba(0,0,0,0.4);
	}
	//np-alert-title
	&-title {
		height: $title-height;
		line-height: $title-height;
		padding: 0 $title-height 0 $space-padding-md;
		font-size: 0;
		background-color: $title-bg;
		border-radius:  $alert-rs $alert-rs 0 0;
		border-bottom: 1px solid $color-border;
		overflow: hidden;
		cursor: move;
		-webkit-user-select: none;
		-ms-user-select: none;
		-moz-user-select: none;
		user-select: none;
		//np-alert-title-text
		&-text {
			font-size: $font-size-md;
			display: inline-block;
			line-height: 1;
			vertical-align: middle;
		}
	}

	//np-alert-close
	&-close {
		position: absolute;
		top: $space-padding-md;
		right: $space-padding-md;
		font-size: $font-size-md;
		cursor: pointer;
	}
	//np-alert-btns_
	&-btns {
		text-align: right;
		padding: 0 $alert-padding $alert-padding ;
		background-color: $alert-color;
		[class *= 'np-alert-btns_btn'] {
			display: inline-block;
			height: $alert-btn-height;
			line-height: $alert-btn-height;
			padding: 0 $space-padding-bs;
			margin: 0 $space-padding-xs;
			border: 1px solid $color-border-input;
			border-radius: $border-radius-xs;
		}
		.np-alert-btns_btn1 {
			background-color: $alert-btn-color;
			color: $alert-color;
			border: 1px solid $alert-btn-color;
		}

		.btn-loading{
			display: none !important;
			margin-left: 10px;
		}
	}
}
</style>
